import { SnapQuoteLinesWithPrices } from '@snap-types/queries/snap-quote-line-with-prices';
import { Decimal } from '@snap-types/types/decimal';

/**
 * Calculate the "total" for a quote if the first quantity
 * of each line were purchased.
 */
export const calculateFirstQtyQuoteTotal = ({
  snapQuoteLinesWithPrices,
}: {
  snapQuoteLinesWithPrices: SnapQuoteLinesWithPrices;
}): { total: Decimal } => {
  const total = snapQuoteLinesWithPrices.reduce((total, line) => {
    if (line.snapQuotePrices.length === 0) {
      return total;
    }

    return total.add(line.snapQuotePrices[0].totalPrice);
  }, new Decimal(0));

  return { total };
};
